import {AnalyticsParameterValue as GQLAnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';

import {PARAMETER_TYPE_TO_CONFIG_TYPENAME} from '../ParameterConstants';
import {ParameterType} from '../ParameterTypes';
import {RESTAnalyticsParameterValue} from '../RESTParameterTypes';

export function convertGQLToRESTParameterValue(
  gqlParameterValue: GQLAnalyticsParameterValue
): RESTAnalyticsParameterValue {
  const {__typename: valueTypename, config, ...otherValueAttrs} = gqlParameterValue;
  return {
    ...otherValueAttrs,
    configId: config.id,
  };
}

export function convertRESTToGQLParameterValue(
  restParameterValue: RESTAnalyticsParameterValue,
  type: ParameterType
): GQLAnalyticsParameterValue {
  const {configId, ...otherValueAttrs} = restParameterValue;
  return {
    ...otherValueAttrs,
    __typename: 'AnalyticsParameterValueNode',
    config: {
      __typename: PARAMETER_TYPE_TO_CONFIG_TYPENAME[type],
      id: configId,
    },
  };
}
